import SpeakersList from './components/Speakerslist';
import SpeakersGrid from './components/SpeakersGrid';

export {
  SpeakersList,
  SpeakersGrid,
};
